import React from "react";
import {
  BlueBirdTheme, Divider, Loading, Typography,
} from "@kitbird/core";
import { useQuery } from "react-query";
import Modal from "../../../../../components/Modal";
import useCloseReceipt from "../../useCloseReceipt";
import LabelAndValue from "../../../CreateReceiptSubmission/components/LabelAndValue";
import { byteStringToFileSize, toRupiah, toStringDate } from "../../../../../utils/common";
import { DescriptionCol, FileItem, FileWrapper } from "../../../CreateReceiptSubmission/components/styles";
import { getDocUrl } from "../../../../../services/bbOneGcsService";
import { ReactComponent as PdfIcon } from "../../../../../assets/icons/pdf_file.svg";
import { ReactComponent as ImgIcon } from "../../../../../assets/icons/img_icon.svg";
import { ReactComponent as ShowIcon } from "../../../../../assets/icons/show_icon.svg";
import { CommonTrxTypes } from "../../../../../enums/common";
import { getDetailTrx } from "../../../../../services/trxService";

interface ModalReceiptDetailProps {
  useCustomHook: ReturnType<typeof useCloseReceipt>;
}

const { gray, primary, secondary } = BlueBirdTheme.colors;
const ModalReceiptDetail = ({ useCustomHook }: ModalReceiptDetailProps) => {
  const {
    detailRedReceipt,
    setDetailRedReceipt,
  } = useCustomHook;

  const { data: detail } = useQuery({
    queryKey: [detailRedReceipt?.trx_id_bm],
    enabled: !!detailRedReceipt,
    queryFn: ({ queryKey }) => (queryKey[0]
      ? getDetailTrx(queryKey[0])
      : undefined
    ),
  });
  return (
    <Modal
      isOpen={!!detailRedReceipt}
      setOpen={() => setDetailRedReceipt(undefined)}
      title="Detail bon"
      body={<div style={{ margin: "-16px", overflowY: "auto", maxHeight: "70vh" }}>
        {detail
          ? <>
            <div style={{ display: "grid", gap: 24, padding: 24 }}>
              <Typography level={6} fontWeight="medium">Detail pemohon</Typography>
              <div style={{ display: "grid", gridTemplateColumns: "192px 16px auto", gap: 16 }}>
                <LabelAndValue label="Nama & NIP" value={<>{detail.employee_name} • <Typography level={6} fontWeight="bold" color={primary[400]}>{detail.employee_nip}</Typography></>} />
                <LabelAndValue label="Wilayah" value={detail.area_name} />
                <LabelAndValue label="Pool" value={detail.pool_id} />
                <LabelAndValue label="Segmen" value={detail.segment.code_description} />
                <LabelAndValue label="Departemen" value={detail.department.department} />
                <LabelAndValue label="Jabatan" value={detail.job_title} />

                <LabelAndValue label="Kode perusahaan" value={detail.company_code} />
                <LabelAndValue label="Perusahaan relasi" value={detail.company_relation || "-"} />
              </div>
            </div>
            <Divider color={secondary[200]} />
            <div style={{ display: "grid", gap: 24, padding: 24 }}>
              <Typography level={6} fontWeight="medium">Detail pengajuan</Typography>
              <div style={{ display: "grid", gridTemplateColumns: "192px 16px auto", gap: 16 }}>
                <LabelAndValue label="No. pengajuan bon" value={detail.trx_id} />
                <LabelAndValue label="Tipe transaksi" value={detail.trx_type.description} />
                <LabelAndValue label="Tanggal pengajuan" value={toStringDate(detail.trx_date)} />
                <LabelAndValue label="Akun GL" value={<>
                  {detail.gnlldr}
                  &nbsp;•&nbsp;
                  {CommonTrxTypes.find(
                    (type) => type.value === detail.sap_shkzg,
                  )?.label}
                  <br />
                  {detail.trx_desc}
                </>} />
                <LabelAndValue label="Total bon" value={toRupiah(detail.amount)} />
                <LabelAndValue label="Rekening tujuan" value={`${detail.bank_account} • ${detail.bank_account_name}`} />
                <LabelAndValue label="Deskripsi" value={(
                  <DescriptionCol>
                    {detail.trx_text}
                  </DescriptionCol>
                )} />
              </div>
            </div>
            <Divider color={secondary[200]} />
            <div style={{ display: "grid", gap: 24, padding: 24 }}>
              <Typography level={6} fontWeight="medium">Lampiran</Typography>
              <FileWrapper>
                {detail.trx_files.map((doc) => (
                  <FileItem onClick={async () => window.open(await getDocUrl(doc))}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {doc.file_name.split(".").pop() === "pdf" ? <PdfIcon /> : <ImgIcon />}
                    </div>
                    <div className="ellipsis-text">
                      {doc.file_name}
                      <div>
                        <Typography level={7} fontWeight="medium">{byteStringToFileSize(doc.file_size)}</Typography>
                      </div>
                    </div>
                    <div style={{ height: 21.6, display: "flex", alignItems: "center" }}>
                      <ShowIcon style={{ color: gray.disable }} />
                    </div>
                  </FileItem>
                ))}
              </FileWrapper>
            </div>
          </>
          : <Loading variant="circular" />
        }
      </div>}
    />
  );
};

export default ModalReceiptDetail;
